export default {
  settings: {
    mimeType: 'application/ld+json',
    corsEnabled: false
  },
  environments: {
    staging: 'https://webhooks.staging-api.immediate.co.uk',
    preproduction: 'https://webhooks.preproduction-api.immediate.co.uk',
    production: 'https://webhooks.api.immediate.co.uk'
  },
  endpoints: {
    mobileBffStaging: {
      endpoint: '/webhooks/mobile-bff-staging'
    },
    mobileBffPreproduction: {
      endpoint: '/webhooks/mobile-bff-preprod'
    },
    mobileBffProduction: {
      endpoint: '/webhooks/mobile-bff'
    },
    openWebProxyLambda: {
      endpoint: '/webhooks/open-web-proxy-lambda'
    }
  }
};